import {
  GET_CUSTOMER_OBJECT_REQUESTING,
  GET_CUSTOMER_SUCCESS
} from './constants';

const INITIAL_STATE = {
  data: null,
  isObjectFetching: false
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_CUSTOMER_OBJECT_REQUESTING: {
      return {
        ...state,
        isObjectFetching: true
      };
    }
    case GET_CUSTOMER_SUCCESS: {
      const data = action.payload;
      return {
        data,
        isObjectFetching: false
      };
    }
    default:
      return state;
  }
};

export default reducer;
